import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "../../backend/firebaseconfig";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // console.log("[ProtectedRoute] Mounting auth listener", {
    //   path: location.pathname,
    // });

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      // console.log("[ProtectedRoute] Auth state changed", {
      //   path: location.pathname,
      //   isSignedIn: !!currentUser,
      //   email: currentUser?.email || null,
      // });

      setUser(currentUser);
      setLoading(false);
    });

    return () => {
      // console.log("[ProtectedRoute] Unmounting auth listener", {
      //   path: location.pathname,
      // });

      unsubscribe();
    };
  }, [location.pathname]);

  if (loading) {
    // console.log("[ProtectedRoute] Loading auth state", {
    //   path: location.pathname,
    // });

    return <div>Loading...</div>;
  }

  if (!user) {
    // console.warn("[ProtectedRoute] Not signed in, redirecting to /", {
    //   attemptedPath: location.pathname,
    // });

    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // console.log("[ProtectedRoute] Access allowed by auth", {
  //   path: location.pathname,
  //   email: user.email,
  // });

  return children;
};

export default ProtectedRoute;
